import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

export default function MultipleLocationsModal({ onClose, onSelectLocation }) {
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography fontSize={24} fontWeight={500} color="textPrimary">
          Attention
        </Typography>
        <IconButton onClick={onClose} edge="end">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={3}
        >
          <InfoIcon color="primary" sx={{ fontSize: 48, mb: 2 }} />
          <Typography fontSize={20} fontWeight={500} color="textPrimary" align="center" sx={{ mb: 2 }}>
            This item was found in multiple locations.
          </Typography>
          <Typography color="textSecondary" align="center" sx={{ mb: 3 }}>
            Please select the one you'd like to move
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={onSelectLocation}
            sx={{ minWidth: 200 }}
          >
            Select Location
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
} 